/**
 * Decider for "random" policy (AB testing)
 * @module
 */

var _ = require('optimizely-client-fn');
var bucketing = require('core/decision/bucketing');
var deciderFns = require('core/decision/decider_fns');
var DecisionError = require('core/decision/error').DecisionError;

/**
 * @constant
 * @type {string}
 */
var RANDOM = 'random';

var pluginDeciderRandom: Decider = {
  /**
   * Select the experiment the visitor should be bucketed into based on the Layer and bucketingId
   * @param {Layer} layer
   * @param {string[]} audienceIds Optionally, audienceIds can be used to decide
   * @param {string} bucketingId
   * @throws {DecisionError} If no eligible experiments in layer
   * @returns {Experiment}
   */
  selectExperiment: function(layer:Layer, audienceIds:string[], bucketingId:string): Experiment {
    if (!layer.weightDistributions && layer.experiments.length > 1) {
      throw new DecisionError('weightDistributions must be defined if # experiments > 1.');
    }

    var selectedExperimentId;

    if (layer.experiments.length === 1) {
      selectedExperimentId = layer.experiments[0].id;
    } else {
      try {
        selectedExperimentId = bucketing.chooseWeightedCandidate(bucketingId, layer.id, layer.weightDistributions);
      } catch(e) {
        throw new DecisionError('No eligible experiments in layer.');
      }
    }

    // Find whole experiment using experiment id
    var selectedExperiment = _.find(layer.experiments, {id: selectedExperimentId});

    if (selectedExperiment && !deciderFns.isValidExperiment(audienceIds, selectedExperiment)) {
      throw new DecisionError('Audience conditions failed for selected experiment: "' + selectedExperimentId + '".');
    }
    if (!selectedExperiment) {
      throw new DecisionError('Unable to find selected experiment: "' + selectedExperimentId + '".');
    }

    return selectedExperiment;
  },
};

module.exports = function(PluginManager) {
  PluginManager.registerDecider(RANDOM, pluginDeciderRandom);
};

if (__TEST__) {
  module.exports.plugin = pluginDeciderRandom;
}
